module.exports = __webpack_public_path__ + "static/001.thumb-097341bc19014d8062875b45dad0cc5c.jpg";